// Angaben zum Anbieter.
//
// An einer Stelle, damit ein Namens- oder Adresswechsel nicht durch zwanzig
// Dateien gejagt werden muss.
export const ANBIETER = 'Quantory Solutions GmbH';
export const ANBIETER_URL = 'https://quantory.de';
/** Ohne Schema — für Stellen, an denen die Adresse gelesen und nicht geklickt wird (Papier). */
export const ANBIETER_DOMAIN = 'quantory.de';
export const POWERED_BY = `powered by ${ANBIETER}`;
export const PRODUKT = 'LagerPro';
